import { render, staticRenderFns } from "./PlacementGoalDetails.vue?vue&type=template&id=da80112e"
import script from "./PlacementGoalDetails.vue?vue&type=script&lang=js"
export * from "./PlacementGoalDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports